<template>
<div>

  <template v-if="hasRealHubs">
    <template v-if="shortened">
      <div class="dropdown" v-if="groupedServices[0]">
        <div class="dropdown-toggle" data-toggle="dropdown" data-boundary="viewport">
          <div class="services-toggle">
            <services-with-hub :hub="groupedServices[0]" :servicesNames="groupedServices[0].services" />
          </div>
        </div>
        <div class="dropdown-menu dropdown-services">
          <div class="dropdown-item">
            <div v-for="hub in groupedServices" :key="hub.id">
              <services-with-hub :hub="hub" :servicesNames="hub.services" :splittedServices="true" />
            </div>
          </div>
        </div>
      </div>
    </template>
    <template v-else>
      <div v-for="hub in groupedServices" :key="hub.id" class="addOn__services">
        <services-with-hub :hub="hub" :servicesNames="hub.services" :splittedServices="splitted" />
      </div>
    </template>
  </template>

  <template v-else>
    <b>{{ services_name }}</b>
  </template>
</div>
</template>

<script>
import ServicesWithHub from '@/components/hubs/ServicesWithHub'
import _ from 'lodash'

export default {
  name: 'ServicesGroupedByHubs',
  components: {
    ServicesWithHub
  },
  props: {
    services: { type: Array, default: () => [] },
    hubs: { type: Array, default: () => [] },
    shortened: { type: Boolean, default: true },
    splitted: { type: Boolean, default: true }
  },
  methods: {
    truncateString(text, max) {
      return text.substr(0, max) + ( text.length > max ? '...' : '');
    }
  },
  computed: {
    services_name() {
      return this.services.map(service => service.name).join(' / ');
    },
    groupedServices() {
      var groupedServices = [];
      var groupedServicesHash = _.groupBy(this.services, 'hub_id');
      Object.keys(groupedServicesHash).forEach((hub_id) => {
        var hub = this.hubs.find((hub) => hub.id == hub_id);
        groupedServices.push({
          name: hub ? hub.name : "",
          id: hub_id,
          services: groupedServicesHash[hub_id].map((service) => service.name).join(' / ')
        })
      })
      return groupedServices
    },
    hasRealHubs() {
      if(!this.hubs || this.hubs.length == 0) {
        return false;
      }

      return this.hubs.filter((hub) => hub.is_fake == false).length > 0;
    },
  }
}
</script>

<style scoped lang="scss">
  @import '../../assets/scss/pages/_var.scss';

  .dropdown {
    max-width: 240px;
  }

  .services-toggle {
    white-space: nowrap;
    overflow: hidden;
    max-width: 218px;
    mask-image: linear-gradient(to right, black calc(100% - 25px), transparent 100%);
  }

  .services-toggle:hover {
    cursor: pointer;
  }

  .users-table .card:hover .services-toggle:after,
  .users-pro-table .card:hover .services-toggle:after,
  .user-entities-cards .card:hover .services-toggle:after{
    background: linear-gradient(to right, rgba(255, 255, 255, 0), #fee7ed 50%);
  }

  .dropdown-services {
    max-height: 23vh;
    .dropdown-item:last-child {
      max-height: 22vh;
    }
  }

  .dropdown-item {
    overflow: auto;
    max-width: 100%;
    max-height: 500px;
  }

  .dropdown-menu {
    background-color: white;
    box-shadow: 0 0px 36px 0 rgba(0, 0, 0, 0.1);
    border: 1px solid rgba(0, 0, 0, 0.1);
    max-width: 95vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/hubs/ServicesGroupedByHubs.vue